import React, { useState, useMemo, useEffect, useRef } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Grid,
  Chip,
  Box,
  IconButton,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  CircularProgress,
  Dialog,
  DialogContent,
  Menu,
  MenuItem,
} from "@mui/material";
import moment from "moment";
import StoreSearch from "../../../Campaign/StoreSearch";
import Decrypt from "../../../../../shared/utils/Decrypt";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import styles from "../../JobBatch.module.css";

import PdfIcon from "../../../../../shared/assets/icons/PdfIcon.png";
import ModalToUpdateBatches from "../../ModalToUpdateBatches";
import RecceReport from "../../../../RFPDashboard/RecceApproval/RecceReport";
import ModalToOpenEditJobs from "../../ModalToOpenEditJobs";
import axios from "axios";

const Accepted = ({
  isAllBatchesLoading,
  forbatch,
  acceptedBatches,
  setAcceptedBatches,
  setTotalAcceptedBatches,
  setAvailableBatches,
  fetchAllJobsBasedOnCampaignId,
  fetchAllBatchesBasedOnCampaignId,
  setIsNotAccepted,
  campaignData,
  fetchAcceptedBatches,
}) => {
  const [expandedBatch, setExpandedBatch] = useState(null);
  const [openModalToUpdateBatch, setOpenModalToUpdateBatch] = useState(false);
  const [detailsOfBatchSelected, setDetailsOfBatchSelected] = useState();
  const [isPaymentAmount, setPaymentAmount] = useState();
  const [openRecceReport, setOpenRecceReport] = useState(false);
  const [currentRecceJob, setCurrentRecceJob] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedJob, setSelectedJob] = useState(null);
  const [openModal, setOpenModal] = useState(false);

  const batchRefs = useRef({});
  const containerRef = useRef(null);

  // Check if Recce service is needed in this campaign
  const isRecceNeeded =
    campaignData?.scopeOfWork?.servicesNeeded?.includes("Recce");

  const handleAccordionToggle = (batchTitle) => (event) => {
    event.stopPropagation();
    setExpandedBatch((prev) => (prev === batchTitle ? null : batchTitle));
  };

  // Function to handle opening the recce report
  const handleOpenRecceReport = (job) => {
    setCurrentRecceJob(job);
    setOpenRecceReport(true);
  };

  // Function to handle closing the recce report
  const handleCloseRecceReport = () => {
    setOpenRecceReport(false);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const updateJobInLocalState = async (job) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.put(
        `${process.env.REACT_APP_URL}/jobs/updateJob/${job._id}`,
        job,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      return response.data.data; // Return the updated job data
    } catch (error) {
      console.error("Error updating job:", error);
      return null;
    }
  };

  const handleSaveJob = async (updatedFields) => {
    if (!selectedJob || !selectedJob._id) {
      console.error("Selected job does not have an id");
      return;
    }

    const updatedJob = await updateJobInLocalState(updatedFields);
    if (updatedJob) {
      handleCloseModal();

      // Refresh the data after successful update
      await fetchAcceptedBatches();
    }
  };
  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleEditJob = () => {
    setOpenModal(true);
    handleCloseMenu();
  };

  // Handle batch updates when IP is assigned/unassigned
  const handleBatchUpdate = (updatedBatch) => {
    // If the IP was unassigned, move the batch to "Not Accepted"
    if (!updatedBatch.installationPartnerId) {
      setAcceptedBatches((prev) =>
        prev.filter((b) => b._id !== updatedBatch._id),
      );
      if (typeof setIsNotAccepted === "function") {
        setIsNotAccepted((prev) => [...prev, updatedBatch]);
      }
    } else {
      // Otherwise, update the batch in the accepted list
      setAcceptedBatches((prev) =>
        prev.map((b) => (b._id === updatedBatch._id ? updatedBatch : b)),
      );
    }

    // Update the details if this is the currently selected batch
    if (detailsOfBatchSelected?._id === updatedBatch._id) {
      setDetailsOfBatchSelected(updatedBatch);
    }
  };

  // Handle the logic to update batches with jobs
  // useEffect(() => {
  //   if (forbatch && acceptedBatches.length > 0) {
  //     const updatedBatches = acceptedBatches.map((batch) => ({
  //       ...batch,
  //       jobs: [],
  //     }));

  //     forbatch.forEach((job) => {
  //       const batch = updatedBatches.find(
  //         (batch) => batch._id === job.batchOfJobsForInstallationPartnerId
  //       );
  //       if (batch) {
  //         batch.jobs.push(job);
  //       }
  //     });

  //     // Calculate the date range for each batch
  //     updatedBatches.forEach((batch) => {
  //       if (batch.jobs.length > 0) {
  //         const jobDates = batch.jobs.map(
  //           (job) => new Date(job.jobStartingDate)
  //         );
  //         const completionDates = batch.jobs.map(
  //           (job) => new Date(job.jobCompletionDate)
  //         );

  //         const earliestDate = new Date(
  //           Math.min(...jobDates.map((date) => date.getTime()))
  //         );
  //         const latestDate = new Date(
  //           Math.max(...completionDates.map((date) => date.getTime()))
  //         );

  //         batch.dateRange = `${earliestDate.toLocaleDateString()} - ${latestDate.toLocaleDateString()}`;
  //       } else {
  //         batch.dateRange = "No Dates Available";
  //       }
  //     });

  //     setAcceptedBatches((prevBatches) => {
  //       const prevBatchesString = JSON.stringify(prevBatches);
  //       const updatedBatchesString = JSON.stringify(updatedBatches);

  //       if (prevBatchesString !== updatedBatchesString) {
  //         return updatedBatches;
  //       } else {
  //         return prevBatches;
  //       }
  //     });

  //     // Update total accepted batches count
  //     const acceptedBatchesCount = updatedBatches.filter(
  //       (batch) => !batch.jobs.every((job) => job.status === 2)
  //     ).length;
  //     setTotalAcceptedBatches(acceptedBatchesCount);
  //   }
  // }, [forbatch, acceptedBatches, setAcceptedBatches, setTotalAcceptedBatches]);
  const handleMenuClick = (event, job) => {
    setAnchorEl(event.currentTarget);
    setSelectedJob(job);
  };

  useEffect(() => {
    if (acceptedBatches && acceptedBatches.length > 0) {
      const updatedBatches = acceptedBatches.map((batch) => {
        // Add jobs to each batch

        // Calculate date range if jobs exist
        if (batch?.jobs?.length > 0) {
          const jobDates = batch.jobs.map(
            (job) => new Date(job.jobStartingDate),
          );
          const completionDates = batch.jobs.map(
            (job) => new Date(job.jobCompletionDate),
          );

          const earliestDate = new Date(
            Math.min(...jobDates.map((date) => date.getTime())),
          );
          const latestDate = new Date(
            Math.max(...completionDates.map((date) => date.getTime())),
          );

          batch.dateRange = `${earliestDate.toLocaleDateString()} - ${latestDate.toLocaleDateString()}`;
          batch.totalPayment = batch.jobs.reduce(
            (sum, job) => sum + (job.paymentAmount || 0),
            0,
          );
        } else {
          batch.dateRange = "No Dates Available";
          batch.totalPayment = 0;
        }

        return batch;
      });

      // Calculate total accepted batches count
      // const acceptedBatchesCount = updatedBatches.filter((batch) =>
      //   batch.jobs.some(
      //     (job) =>
      //       job.status === 0 && new Date(job.jobCompletionDate) < new Date()
      //   )
      // ).length;
      // setAcceptedBatches(acceptedBatchesCount);
    }
  }, [acceptedBatches, setAcceptedBatches]);

  const searchData = useMemo(() => {
    const result = [];

    acceptedBatches.forEach((batch) => {
      batch.jobs?.forEach((job) => {
        result.push({
          id: job._id,
          storeName: job.storeName,

          batchTitle: batch.batchTitle,

          targetId: batch._id,

          subText: `Batch: ${batch.batchTitle}`,
        });
      });
    });

    return result;
  }, [acceptedBatches]);

  return (
    <Grid ref={containerRef} className={`${styles.scrollableContainer}`}>
      <div
        className="mx-3 py-2 sticky top-0 z-20 bg-white"
        
      >
        <StoreSearch
          data={searchData}
          searchKey="storeName"
          placeholder="Search Store Name"
          containerRef={containerRef}
          targetRefs={batchRefs}
          onSelect={(item) => {
            setExpandedBatch(item.batchTitle);
          }}
        />
      </div>
      {isAllBatchesLoading ? (
        <div className={styles.noJobsStyle}>
          <CircularProgress />
        </div>
      ) : acceptedBatches?.length > 0 ? (
        acceptedBatches.map((batch, index) => {
          return (
            <Grid
              ref={(el) => (batchRefs.current[batch._id] = el)}
              item
              xs={12}
              md={12}
              key={index}
              my={1}
              mx={2}
            >
              <Accordion expanded={expandedBatch === batch.batchTitle}>
                <AccordionSummary
                  expandIcon={
                    <IconButton
                      onClick={handleAccordionToggle(batch.batchTitle)}
                    >
                      <ExpandMoreIcon />
                    </IconButton>
                  }
                  aria-controls={`panel-${index}-content`}
                  id={`panel-${index}-header`}
                >
                  <div className="flex items-center justify-between p-4 rounded-lg bg-white w-full mx-auto">
                    {/* Section 1: Batch Title */}
                    <div className="flex">
                      <h1 className={`${styles.batchTitle}`}>
                        {batch.batchTitle}
                      </h1>
                    </div>

                    {/* Section 2: Other Details */}
                    <div className={styles.chipContainer}>
                      <div>
                        <Chip
                          label={`Timeline: ${moment(
                            batch?.jobStartingDate,
                          ).format("DD MMM YY")} - ${moment(
                            batch?.jobCompletionDate,
                          ).format("DD MMM YY")}`}
                          className={styles.chip}
                        />
                      </div>
                      <Chip
                        key={index}
                        label={
                          batch.installationPartnerId
                            ? `${batch.installationPartnerId.name} - ${
                                Decrypt(
                                  batch.installationPartnerId.phoneNumber,
                                ) || "N/A"
                              }`
                            : "No Contact Info"
                        }
                        className={styles.chip}
                      />
                      <Chip
                        label={
                          batch.jobs?.every((job) => job.status === 2)
                            ? "Complete"
                            : `Pending: ${
                                batch.jobs?.filter((job) => job.status !== 2)
                                  .length || 0
                              }`
                        }
                        className={
                          batch.jobs?.every((job) => job.status === 2)
                            ? styles.amountPaid
                            : styles.pending
                        }
                      />
                      <Chip
                        label={
                          <span>Batch Payment: ₹{batch?.paymentAmount}</span>
                        }
                        className={styles.chips}
                      />
                      <Chip
                        label={<span>Jobs: {batch?.jobs?.length || 0}</span>}
                        className={styles.chip}
                      />
                      <button
                        className="text-gray-400 hover:text-gray-600 text-xl rounded-full px-4 py-1 hover:bg-gray-100"
                        onClick={() => {
                          setOpenModalToUpdateBatch(true);
                          setDetailsOfBatchSelected(batch);
                          // setPaymentAmount(batch?.totalPayment);
                        }}
                      >
                        ⋮
                      </button>
                    </div>
                  </div>
                </AccordionSummary>

                <AccordionDetails className={styles.accordionDetail}>
                  <Box className={`${styles.scrollableBox}`}>
                    <TableContainer component={Paper}>
                      <Table>
                        <TableHead>
                          <TableRow className={styles.tableHeader}>
                            <TableCell className={styles.tableCell}>
                              ADDRESS
                            </TableCell>
                            <TableCell className={styles.tableCell}>
                              STORE MANAGER
                            </TableCell>
                            <TableCell className={styles.tableCell}>
                              PRODUCT TYPE
                            </TableCell>
                            <TableCell className={styles.tableCell}>
                              DRIVER DETAILS
                            </TableCell>
                            <TableCell className={styles.tableCell}>
                              JOB PAY
                            </TableCell>
                            {isRecceNeeded && (
                              <TableCell className={styles.tableCell}>
                                RECCE REPORT
                              </TableCell>
                            )}
                            <TableCell className={styles.tableCell}>
                              JOB STATUS
                            </TableCell>
                            <TableCell className={styles.tableCell}>
                              ACTION
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {batch?.jobs?.map((row, index) => (
                            <TableRow key={index}>
                              <TableCell className={styles.tableCell}>
                                <div className={styles.sharedTextStyle}>
                                  <span>{row.storeName}</span>
                                </div>
                                <div className={styles.address2}>
                                  <span>{row.city}</span>,{" "}
                                  <span>{row.state}</span>,{" "}
                                  <span>{row.zipCode}</span>
                                </div>
                              </TableCell>
                              <TableCell className={styles.tableCell}>
                                <div className={styles.sharedTextStyle}>
                                  {row.storeOwnerName}
                                </div>
                                <div className={styles.storeManagerContact}>
                                  {row.storeOwnerPhoneNumber}
                                </div>
                              </TableCell>
                              <TableCell className={styles.tableCell}>
                                <div className={styles.sharedTextStyle}>
                                  {row?.productId?.productType || "NA"}
                                </div>
                              </TableCell>
                              <TableCell className={styles.tableCell}>
                                <div className={styles.sharedTextStyle}>
                                  {row.driverDetails?.driverName || "NA"}
                                </div>
                                <div className={styles.address2}>
                                  {row.driverDetails?.driverPhoneNumber || "NA"}{" "}
                                  | {row.driverDetails?.vehicleNumber || "NA"}
                                </div>
                              </TableCell>
                              <TableCell className={styles.tableCell}>
                                <div className={styles.sharedTextStyle}>
                                  ₹{row.paymentAmount}
                                </div>
                              </TableCell>
                              {isRecceNeeded && (
                                <TableCell className={styles.tableCell}>
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => handleOpenRecceReport(row)}
                                  >
                                    <img
                                      src={PdfIcon}
                                      alt="PDF Icon"
                                      style={{
                                        width: "20px",
                                        height: "20px",
                                        marginRight: "8px",
                                      }}
                                    />
                                    <a
                                      href="#"
                                      style={{
                                        cursor: "pointer",
                                        textDecoration: "none",
                                        color: "inherit",
                                      }}
                                    >
                                      {row.RecceReport}
                                    </a>
                                  </div>
                                </TableCell>
                              )}
                              <TableCell className={styles.tableCell}>
                                <Chip
                                  label={
                                    row.status === 0
                                      ? "pending"
                                      : row.status === 2
                                        ? "complete"
                                        : row.status === 1
                                          ? "in progress"
                                          : row.status
                                  }
                                  className={
                                    row.status === 2
                                      ? styles.amountPaid
                                      : row.status === 0
                                        ? styles.pending
                                        : row.status === 1
                                          ? styles.inProgress
                                          : ""
                                  }
                                />
                              </TableCell>
                              <TableCell className={styles.tableCell}>
                                {
                                  <IconButton
                                    onClick={(event) =>
                                      handleMenuClick(event, row)
                                    }
                                  >
                                    <MoreVertIcon />
                                  </IconButton>
                                }
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Box>
                </AccordionDetails>
              </Accordion>
            </Grid>
          );
        })
      ) : (
        <div className={styles.noJobsStyle}>
          <Typography
            variant="h6"
            align="center"
            className={`${styles.noJobsBox} ${styles.noJobsText}`}
          >
            No batches available
          </Typography>
        </div>
      )}
      {openModalToUpdateBatch && (
        <ModalToUpdateBatches
          openModal={openModalToUpdateBatch}
          setOpenModalToUpdateBatch={setOpenModalToUpdateBatch}
          batch={detailsOfBatchSelected}
          setAvailableBatches={setAvailableBatches}
          fetchAllJobsBasedOnCampaignId={fetchAllJobsBasedOnCampaignId}
          fetchAllBatchesBasedOnCampaignId={fetchAllBatchesBasedOnCampaignId}
          isPaymentAmount={isPaymentAmount}
          onBatchUpdate={handleBatchUpdate}
          setAcceptedBatches={setAcceptedBatches}
          setIsNotAccepted={setIsNotAccepted}
          campaignData={campaignData}
        />
      )}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleCloseMenu}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <MenuItem onClick={handleEditJob}>Edit Job</MenuItem>
      </Menu>
      <ModalToOpenEditJobs
        open={openModal}
        handleClose={handleCloseModal}
        selectedJob={selectedJob}
        setSelectedJob={setSelectedJob}
        handleSaveJob={handleSaveJob}
        installationCheck={true}
      />

      {/* Recce Report Dialog */}
      <Dialog
        open={openRecceReport}
        onClose={handleCloseRecceReport}
        maxWidth="lg"
        fullWidth
        className="custom-dialog"
        PaperProps={{
          className: "custom-dialog-paper",
        }}
      >
        <DialogContent>
          {currentRecceJob && (
            <RecceReport
              setOpen={setOpenRecceReport}
              open={openRecceReport}
              currentApproval={currentRecceJob}
              finalSpaces={[]}
              installationCheck={true}
            />
          )}
        </DialogContent>
      </Dialog>
    </Grid>
  );
};

export default Accepted;
